import { number } from "../config";

/**
 * Generates styles for the tour guide based on the current step and resetTour flag
 * @author Bhavana
 */
export const getTourGuideStyles = (resetTour, currentStep) => {
  return {
    options: {
      width: 300,
      arrowColor: "white",
      backgroundColor: "white",
      overlayColor: "transparent",
      textColor: "black",
      zIndex: 1000,
    },
    spotlight: {
      backgroundColor: "transparent",
    },
    spotlightShadow: "0 0 15px rgba(0, 0, 0, 0.5)",
    beaconSize: 16,
    buttonNext: {
      color: "#007bff",
      backgroundColor: "transparent",
    },
    buttonBack: {
      color: "#007bff",
      display: (currentStep == number.ONE && resetTour) ? 'none' : 'inline-block'
    },
    buttonClose: {
      color: "grey",
    },
    buttonSkip: {
      color: "#007bff",
    },
  };
};

/**
 * Locale configuration object for Joyride tour buttons
 *@author Bhavana
 * */
export const tourLocale = {
  back: 'Previous',
  close: 'Close',
  last: 'Finish',
  next: 'Next',
  skip: 'Skip',
}
